import useThemePreference, { useVibe } from "../../Hook/theme";
import { THEME_PREFERENCES, VIBES } from "../../theme/mode";
import scale from "../../theme/scale.json";
import Segmented from "./Segmented";

/**
 * Light / Dark / System.
 *
 * Three values, because System is a standing instruction to follow the OS rather than
 * a third appearance, and a two-state toggle cannot say that. It is also the default.
 */
export function AppearanceSwitch({ className }: { className?: string }) {
  const [preference, setPreference] = useThemePreference();

  return (
    <Segmented
      testId="appearance-switch"
      className={className}
      value={preference}
      options={THEME_PREFERENCES}
      onPick={setPreference}
      label={(option) => `appearance__${option}`}
    />
  );
}

/** The softness axis. A handful of radii, and every corner in the product follows. */
export function VibeSwitch({ className }: { className?: string }) {
  const [vibe, setVibe] = useVibe();

  return (
    <Segmented
      testId="vibe-switch"
      className={className}
      value={vibe}
      options={VIBES}
      onPick={setVibe}
      label={(option) => scale.vibes[option].label}
    />
  );
}

export default AppearanceSwitch;
